export enum CarrierDashboardEnum {
    MODULE_ACCESS = 'View',
    FILTER_BY_VIEW = 'Filter_by_View',
    FILTER_BY_EDIT = 'Filter_by_Edit',
    CARRIER_DASHBOARD_GRID_VIEW = 'Carrier_Dashboard_Grid_View',
    CARRIER_DASHBOARD_GRID_EDIT = 'Carrier_Dashboard_Grid_Edit',
}
